export default __webpack_public_path__ + "static/media/AZ_MRL-3.6111c175.jpg";